(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6873],{

/***/ 7253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hz": function() { return /* binding */ suggestAlertSlug; },
/* harmony export */   "I$": function() { return /* binding */ checkAlertSlug; },
/* harmony export */   "bc": function() { return /* binding */ apiErrorMessage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10092);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46979);



// Admin-only slug tools behind the alert form's URL field. Both call the axios
// instance directly so the API's own message (e.g. a 409) reaches the admin.
var unwrap = function(res) {
    return res.data.data;
};
// Short default built from the subject line, already made unique.
var suggestAlertSlug = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(title) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/alerts/slug-tools/suggest", {
                            params: {
                                title: title
                            }
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function suggestAlertSlug(title) {
        return _ref.apply(this, arguments);
    };
}();
// { slug: normalised, available }. alertId excludes the alert being edited.
var checkAlertSlug = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(slug, alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/alerts/slug-tools/availability", {
                            params: alertId ? {
                                slug: slug,
                                alertId: alertId
                            } : {
                                slug: slug
                            }
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function checkAlertSlug(slug, alertId) {
        return _ref.apply(this, arguments);
    };
}();
var apiErrorMessage = function(payload, fallback) {
    var message = payload === null || payload === void 0 ? void 0 : payload.message;
    if (Array.isArray(message)) return message.join(" ");
    return typeof message === "string" && message ? message : fallback;
};


/***/ }),

/***/ 25340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N5": function() { return /* binding */ fetchResearchSponsorship; },
/* harmony export */   "Pg": function() { return /* binding */ fetchResearchOffer; },
/* harmony export */   "iE": function() { return /* binding */ fetchResearchStrip; },
/* harmony export */   "io": function() { return /* binding */ reserveResearchSponsorship; },
/* harmony export */   "kQ": function() { return /* binding */ forceReleaseResearchSponsorship; },
/* harmony export */   "nx": function() { return /* binding */ releaseResearchSponsorship; },
/* harmony export */   "rH": function() { return /* binding */ saveResearchOffer; },
/* harmony export */   "vI": function() { return /* binding */ setResearchSponsorHidden; },
/* harmony export */   "w9": function() { return /* binding */ fetchResearchSponsorshipAdmin; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10092);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46979);



// Story sponsorship (research). Called on the raw axios instance, like
// api/faq-sponsor.js, so the API's message and code reach the page.
var unwrap = function(res) {
    return res.data.data;
};
// The alert page is cached; this is the box's live status. Null when not on offer.
var fetchResearchSponsorship = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/research-sponsorship/".concat(alertId))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchResearchSponsorship(alertId) {
        return _ref.apply(this, arguments);
    };
}();
// The strip under an open alert's headline: { price } while the offer is for sale, else null.
var fetchResearchStrip = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/research-sponsorship/".concat(alertId, "/strip"))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchResearchStrip(alertId) {
        return _ref.apply(this, arguments);
    };
}();
// The offer's text and price, for logged-in experts only. Null when there is none for them.
var fetchResearchOffer = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/research-sponsorship/".concat(alertId, "/offer"))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchResearchOffer(alertId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchResearchSponsorshipAdmin = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/research-sponsorship/".concat(alertId, "/admin"))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchResearchSponsorshipAdmin(alertId) {
        return _ref.apply(this, arguments);
    };
}();
var saveResearchOffer = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId, body) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put("/research-sponsorship/".concat(alertId), body)
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function saveResearchOffer(alertId, body) {
        return _ref.apply(this, arguments);
    };
}();
// { status, url?, reservationToken? }. Logged-in experts only: `api` carries the member's token.
var reserveResearchSponsorship = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId, body) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/research-sponsorship/".concat(alertId, "/reserve"), body)
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function reserveResearchSponsorship(alertId, body) {
        return _ref.apply(this, arguments);
    };
}();
var releaseResearchSponsorship = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId, reservationToken) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/research-sponsorship/".concat(alertId, "/release"), {
                            reservationToken: reservationToken
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function releaseResearchSponsorship(alertId, reservationToken) {
        return _ref.apply(this, arguments);
    };
}();
// Sold only: hide the box and the credit, or show them again.
var setResearchSponsorHidden = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId, hidden) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put("/research-sponsorship/".concat(alertId, "/sponsor"), {
                            hidden: hidden
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function setResearchSponsorHidden(alertId, hidden) {
        return _ref.apply(this, arguments);
    };
}();
// Reserved only. { status } is where the slot ended up. confirmedInStripe: the
// editor has checked the session in Stripe, so one completed unpaid is released too.
var forceReleaseResearchSponsorship = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        var confirmedInStripe;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    confirmedInStripe = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/research-sponsorship/".concat(alertId, "/force-release"), confirmedInStripe ? {
                            confirmedInStripe: confirmedInStripe
                        } : undefined)
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function forceReleaseResearchSponsorship(alertId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 81252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Alert_DatePicker; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@date-io/date-fns/build/index.esm.js + 107 modules
var index_esm = __webpack_require__(23433);
// EXTERNAL MODULE: ./node_modules/@material-ui/pickers/esm/useUtils-cfb96ac9.js
var useUtils_cfb96ac9 = __webpack_require__(87827);
// EXTERNAL MODULE: ./node_modules/@material-ui/pickers/esm/DatePicker.js
var DatePicker = __webpack_require__(63430);
// EXTERNAL MODULE: ./styles/modules/newsAlert/InputPicker.module.scss
var InputPicker_module = __webpack_require__(15260);
var InputPicker_module_default = /*#__PURE__*/__webpack_require__.n(InputPicker_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./components/Svg/Calendar.js



function Calendar(props) {
    var fill = props.fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.25 0.25V2.5H14.5V0.25H18.25V2.5H19.75V6.25H0.25V2.5H2.5V0.25H6.25Z",
                fill: fill ? fill : "#212121"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.75 8.5H0.25V20.5H19.75V8.5Z",
                fill: fill ? fill : "#212121"
            })
        ]
    }));
}

;// CONCATENATED MODULE: ./components/Alert/DatePicker.js





var DatePicker_DatePicker = function(param) {
    var date = param.date, setDate = param.setDate, setDateValid = param.setDateValid;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (InputPicker_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useUtils_cfb96ac9.M, {
            utils: index_esm/* default */.Z,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePicker/* KeyboardDatePicker */.e, {
                ampm: false,
                value: date,
                onChange: function(value) {
                    return setDate(value);
                },
                className: (InputPicker_module_default()).picker,
                format: "dd/MM/yyyy",
                keyboardIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Calendar, {}),
                onError: function(error) {
                    return setDateValid(!error);
                },
                disablePast: true
            })
        })
    });
};
/* harmony default export */ var Alert_DatePicker = (DatePicker_DatePicker);


/***/ }),

/***/ 63302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44217);
/* harmony import */ var api_alert_slug__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7253);
/* harmony import */ var api_research_sponsorship__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25340);
/* harmony import */ var utils_research_sponsor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25374);
/* harmony import */ var styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51495);
/* harmony import */ var styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var lang_en_json__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64798);












var copy = lang_en_json__WEBPACK_IMPORTED_MODULE_6__/* .news_alerts.research_sponsor */ .RA.qh;
var ARM_MS = 5000;
// Once a buyer has reserved or paid, the offer is fixed; these act on the sale instead.
var LockedActions = function(param) {
    var alertId = param.alertId, row = param.row, onRowChange = param.onRowChange, setNotice = param.setNotice;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), busy = ref[0], setBusy = ref[1];
    // The button clicked once; a second click within ARM_MS runs it.
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), armed = ref1[0], setArmed = ref1[1];
    // Stripe would not expire the session: the editor may release it once checked.
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), stillOpen = ref2[0], setStillOpen = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!armed) return;
        var timer = setTimeout(function() {
            return setArmed(null);
        }, ARM_MS);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        armed
    ]);
    var run = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(key, action, fallback) {
            var result, err, ref, fresh, e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setBusy(key);
                        setArmed(null);
                        setNotice(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            action()
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        result = {
                            type: "error",
                            text: (0,api_alert_slug__WEBPACK_IMPORTED_MODULE_3__/* .apiErrorMessage */ .bc)(err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : ref.data, fallback)
                        };
                        return [
                            3,
                            4
                        ];
                    case 4:
                        fresh = null;
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4,
                            (0,api_research_sponsorship__WEBPACK_IMPORTED_MODULE_4__/* .fetchResearchSponsorshipAdmin */ .w9)(alertId)
                        ];
                    case 6:
                        fresh = _state.sent();
                        return [
                            3,
                            8
                        ];
                    case 7:
                        e = _state.sent();
                        result = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, result), {
                            text: "".concat(result.text, " ").concat(copy.admin_refresh_failed)
                        });
                        return [
                            3,
                            8
                        ];
                    case 8:
                        setNotice(result);
                        setBusy(null);
                        // Last: a released offer is editable again, which unmounts these actions.
                        if (fresh) onRowChange(fresh);
                        return [
                            2
                        ];
                }
            });
        });
        return function run(key, action, fallback) {
            return _ref.apply(this, arguments);
        };
    }();
    var toggleHidden = function() {
        return run("hide", /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,api_research_sponsorship__WEBPACK_IMPORTED_MODULE_4__/* .setResearchSponsorHidden */ .vI)(alertId, !row.hidden)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2,
                            {
                                type: "ok",
                                text: row.hidden ? copy.admin_shown_ok : copy.admin_hidden_ok
                            }
                        ];
                }
            });
        }), copy.admin_sponsor_failed);
    };
    var release = function(confirmedInStripe) {
        return run(confirmedInStripe ? "confirmed" : "release", /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
            var status;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,api_research_sponsorship__WEBPACK_IMPORTED_MODULE_4__/* .forceReleaseResearchSponsorship */ .kQ)(alertId, confirmedInStripe)
                        ];
                    case 1:
                        status = _state.sent().status;
                        setStillOpen(status === "reserved");
                        if (status === "reserved") {
                            return [
                                2,
                                {
                                    type: "error",
                                    text: copy.admin_still_open
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                type: "ok",
                                text: status === "sold" ? copy.admin_now_sold : copy.admin_released
                            }
                        ];
                }
            });
        }), copy.admin_release_failed);
    };
    var confirmButton = function(key, title, action) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            title: armed === key ? copy.admin_confirm : title,
            theme: "danger",
            loading: busy === key,
            disabled: Boolean(busy) && busy !== key,
            onClick: function() {
                return armed === key ? action() : setArmed(key);
            }
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_11___default().editorActions),
                children: [
                    row.status === "sold" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        title: row.hidden ? copy.admin_show : copy.admin_hide,
                        theme: "secondary",
                        loading: busy === "hide",
                        onClick: toggleHidden
                    }),
                    row.status === "reserved" && confirmButton("release", copy.admin_force_release, function() {
                        return release(false);
                    }),
                    row.status === "reserved" && stillOpen && confirmButton("confirmed", copy.admin_force_confirmed, function() {
                        return release(true);
                    })
                ]
            }),
            row.status === "reserved" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_11___default().hint),
                children: copy.admin_release_hint
            })
        ]
    });
};
// Admins only. `row` is the saved offer from the admin endpoint, null before the
// first save; without `onRowChange` (alert create) there is no sale to act on.
// `legend` off where the page gives the section its own heading.
var ResearchSponsorFields = function(param) {
    var alertId = param.alertId, draft = param.draft, row = param.row, onChange = param.onChange, onRowChange = param.onRowChange, _legend = param.legend, legend = _legend === void 0 ? true : _legend;
    // Here, not in LockedActions: a release makes the offer editable again and
    // unmounts them, and the notice has to outlive that.
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), notice = ref[0], setNotice = ref[1];
    var notices = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        "aria-live": "polite",
        children: notice && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            className: notice.type === "error" ? (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_11___default().error) : (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_11___default().ok),
            children: notice.text
        })
    });
    if ((0,utils_research_sponsor__WEBPACK_IMPORTED_MODULE_5__/* .researchOfferLocked */ .BA)(row)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("fieldset", {
            className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_11___default().faqOffer),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("legend", {
                    className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_11___default().kicker),
                    children: copy.admin_legend
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_11___default().faqStatus),
                    children: [
                        (0,utils_research_sponsor__WEBPACK_IMPORTED_MODULE_5__/* .researchAdminStatus */ .MR)(row),
                        row.hidden ? " \xb7 ".concat(copy.admin_hidden) : ""
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_11___default().hint),
                    children: [
                        (0,utils_research_sponsor__WEBPACK_IMPORTED_MODULE_5__/* .priceLabel */ .gX)(row.pricePence),
                        " + VAT \xb7 ",
                        row.researchDetail
                    ]
                }),
                onRowChange && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LockedActions, {
                    alertId: alertId,
                    row: row,
                    onRowChange: onRowChange,
                    setNotice: setNotice
                }),
                notices
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("fieldset", {
        className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_11___default().faqOffer),
        children: [
            legend && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("legend", {
                className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_11___default().kicker),
                children: copy.admin_legend
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_11___default().checkboxLabel),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "checkbox",
                        checked: draft.enabled,
                        onChange: function(e) {
                            return onChange("enabled", e.target.checked);
                        }
                    }),
                    copy.admin_toggle
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_11___default().hint),
                children: copy.admin_hint
            }),
            draft.enabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                        className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_11___default().label),
                        htmlFor: "research-detail",
                        children: [
                            copy.admin_detail,
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_11___default().count),
                                children: [
                                    "(",
                                    draft.researchDetail.length,
                                    "/",
                                    utils_research_sponsor__WEBPACK_IMPORTED_MODULE_5__/* .RESEARCH_TEXT_MAX */ .K,
                                    ")"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_11___default().hint),
                        id: "research-detail-hint",
                        children: copy.admin_detail_hint
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                        id: "research-detail",
                        "aria-describedby": "research-detail-hint",
                        className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_11___default().textarea),
                        rows: 5,
                        maxLength: utils_research_sponsor__WEBPACK_IMPORTED_MODULE_5__/* .RESEARCH_TEXT_MAX */ .K,
                        required: true,
                        value: draft.researchDetail,
                        onChange: function(e) {
                            return onChange("researchDetail", e.target.value);
                        }
                    }),
                    (0,utils_research_sponsor__WEBPACK_IMPORTED_MODULE_5__/* .researchTextTooLong */ .dp)(draft, row === null || row === void 0 ? void 0 : row.researchDetail) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_11___default().error),
                        role: "alert",
                        children: utils_research_sponsor__WEBPACK_IMPORTED_MODULE_5__/* .RESEARCH_TEXT_TOO_LONG */ .RY
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                        className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_11___default().label),
                        htmlFor: "research-price",
                        children: copy.admin_price
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("select", {
                        id: "research-price",
                        className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_11___default().input),
                        value: draft.pricePence,
                        onChange: function(e) {
                            return onChange("pricePence", Number(e.target.value));
                        },
                        children: utils_research_sponsor__WEBPACK_IMPORTED_MODULE_5__/* .RESEARCH_PRICES.map */ .fp.map(function(pence) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                value: pence,
                                children: "".concat((0,utils_research_sponsor__WEBPACK_IMPORTED_MODULE_5__/* .priceLabel */ .gX)(pence), " + VAT")
                            }, pence);
                        })
                    })
                ]
            }),
            notices
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ResearchSponsorFields);


/***/ }),

/***/ 60717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var api_alert_slug__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7253);
/* harmony import */ var lang_en__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64798);
/* harmony import */ var styles_modules_newsAlert_SlugField_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48390);
/* harmony import */ var styles_modules_newsAlert_SlugField_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(styles_modules_newsAlert_SlugField_module_scss__WEBPACK_IMPORTED_MODULE_6__);







var DEBOUNCE_MS = 400;
// Admin-only: the address the alert lives at. On create it follows the subject
// line (short, stop words dropped) until the admin types their own. Whatever is
// in the field is checked against every current and retired alert slug, so a
// taken address shows up before the save does. `onStatus` tells the parent
// whether the value can be submitted.
var SlugField = function(param) {
    var value = param.value, onChange = param.onChange, onStatus = param.onStatus, title = param.title, alertId = param.alertId, _suggestFromTitle = param.suggestFromTitle, suggestFromTitle = _suggestFromTitle === void 0 ? false : _suggestFromTitle, _currentSlug = param.currentSlug, currentSlug = _currentSlug === void 0 ? null : _currentSlug;
    var copy = lang_en__WEBPACK_IMPORTED_MODULE_3__/* .news_alerts.create_alert.screen_1 */ .RA.It.n9;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), touched = ref[0], setTouched = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), check = ref1[0], setCheck = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), checking = ref2[0], setChecking = ref2[1];
    var latest = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
    var unchanged = Boolean(currentSlug) && value === currentSlug;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!suggestFromTitle || touched || !(title === null || title === void 0 ? void 0 : title.trim())) {
            return undefined;
        }
        // A reply that lands after the admin started typing, or after the
        // title changed again, must not overwrite the field.
        var cancelled = false;
        var timer = setTimeout(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
            var slug, err;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0,api_alert_slug__WEBPACK_IMPORTED_MODULE_2__/* .suggestAlertSlug */ .Hz)(title)
                        ];
                    case 1:
                        slug = _state.sent().slug;
                        if (!cancelled) onChange(slug);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        console.warn("slug suggestion failed", err);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        }), DEBOUNCE_MS);
        return function() {
            cancelled = true;
            clearTimeout(timer);
        };
    }, [
        title,
        touched,
        suggestFromTitle
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // Every change invalidates whatever check is in flight, including a
        // change back to empty or to the current address, so a late reply can
        // never flag the field as taken.
        var seq = ++latest.current;
        setCheck(null);
        if (!(value === null || value === void 0 ? void 0 : value.trim()) || unchanged) {
            setChecking(false);
            return undefined;
        }
        setChecking(true);
        var timer = setTimeout(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
            var result, err;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        return [
                            4,
                            (0,api_alert_slug__WEBPACK_IMPORTED_MODULE_2__/* .checkAlertSlug */ .I$)(value, alertId)
                        ];
                    case 1:
                        result = _state.sent();
                        if (seq === latest.current) setCheck(result);
                        return [
                            3,
                            4
                        ];
                    case 2:
                        err = _state.sent();
                        console.warn("slug check failed", err);
                        if (seq === latest.current) setCheck(null);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        if (seq === latest.current) setChecking(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }), DEBOUNCE_MS);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        value,
        alertId,
        unchanged
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!onStatus) return;
        // Submittable unless we know the address is taken or it is unusable.
        var unusable = Boolean(value === null || value === void 0 ? void 0 : value.trim()) && check && !check.slug;
        onStatus({
            ok: !checking && !(check && check.available === false) && !unusable,
            checking: checking
        });
    }, [
        check,
        checking,
        value
    ]);
    var status = null;
    var statusClass = "";
    if (unchanged) {
        status = copy.slug_current;
    } else if (checking) {
        status = copy.slug_checking;
    } else if (check && !check.slug) {
        status = copy.slug_unusable;
        statusClass = (styles_modules_newsAlert_SlugField_module_scss__WEBPACK_IMPORTED_MODULE_6___default().taken);
    } else if (check && check.available === false) {
        status = copy.slug_taken;
        statusClass = (styles_modules_newsAlert_SlugField_module_scss__WEBPACK_IMPORTED_MODULE_6___default().taken);
    } else if (check) {
        status = check.slug !== value ? "".concat(copy.slug_available, " /news-alerts/").concat(check.slug) : copy.slug_available;
        statusClass = (styles_modules_newsAlert_SlugField_module_scss__WEBPACK_IMPORTED_MODULE_6___default().available);
    } else if (!(value === null || value === void 0 ? void 0 : value.trim())) {
        status = copy.slug_hint;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (styles_modules_newsAlert_SlugField_module_scss__WEBPACK_IMPORTED_MODULE_6___default().wrapper),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                className: (styles_modules_newsAlert_SlugField_module_scss__WEBPACK_IMPORTED_MODULE_6___default().label),
                htmlFor: "alert-slug",
                children: copy.slug_label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (styles_modules_newsAlert_SlugField_module_scss__WEBPACK_IMPORTED_MODULE_6___default().row),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (styles_modules_newsAlert_SlugField_module_scss__WEBPACK_IMPORTED_MODULE_6___default().prefix),
                        children: "/news-alerts/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        id: "alert-slug",
                        name: "slug",
                        type: "text",
                        className: (styles_modules_newsAlert_SlugField_module_scss__WEBPACK_IMPORTED_MODULE_6___default().input),
                        value: value || "",
                        autoComplete: "off",
                        spellCheck: false,
                        onChange: function(event) {
                            setTouched(true);
                            onChange(event.target.value);
                        }
                    })
                ]
            }),
            status && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: [
                    (styles_modules_newsAlert_SlugField_module_scss__WEBPACK_IMPORTED_MODULE_6___default().status),
                    statusClass
                ].join(" "),
                children: status
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SlugField);


/***/ }),

/***/ 8342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_Input__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21105);
/* harmony import */ var components_Checkbox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25113);
/* harmony import */ var utils_source_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93373);
/* harmony import */ var styles_modules_newsAlert_SourcePage_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(283);
/* harmony import */ var styles_modules_newsAlert_SourcePage_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(styles_modules_newsAlert_SourcePage_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lang_en_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64798);






var copy = lang_en_json__WEBPACK_IMPORTED_MODULE_3__/* .news_alerts.create_alert.screen_3 */ .RA.It.QG;
var SourcePageFields = function(param) {
    var sourceUrl = param.sourceUrl, sourceLabel = param.sourceLabel, isSponsored = param.isSponsored, canSponsor = param.canSponsor, onChange = param.onChange;
    var labelTooLong = (sourceLabel || "").length > utils_source_page__WEBPACK_IMPORTED_MODULE_4__/* .SOURCE_LABEL_MAX */ .Uo;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (styles_modules_newsAlert_SourcePage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().fields),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (styles_modules_newsAlert_SourcePage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().description),
                children: copy.source_description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Input__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                name: "sourceUrl",
                type: "url",
                labelAbove: true,
                label: copy.source_url,
                value: sourceUrl || "",
                onChange: function(e) {
                    return onChange("sourceUrl", e.target.value);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Input__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                name: "sourceLabel",
                labelAbove: true,
                label: copy.source_label,
                value: sourceLabel || "",
                onChange: function(e) {
                    return onChange("sourceLabel", e.target.value);
                },
                error: labelTooLong && {
                    message: "Max ".concat(utils_source_page__WEBPACK_IMPORTED_MODULE_4__/* .SOURCE_LABEL_MAX */ .Uo, " characters")
                }
            }),
            canSponsor && ((sourceUrl === null || sourceUrl === void 0 ? void 0 : sourceUrl.trim()) || isSponsored) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Checkbox__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        name: "isSponsored",
                        label: copy.source_sponsored,
                        initialValue: !!isSponsored,
                        onChange: function() {
                            return onChange("isSponsored", !isSponsored);
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (styles_modules_newsAlert_SourcePage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().hint),
                        children: copy.source_sponsored_hint
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SourcePageFields);


/***/ }),

/***/ 14530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ ALERT_EDITOR_CONFIG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25617);
/* harmony import */ var store_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32505);
/* harmony import */ var styles_modules_newsAlert_TemplateFields_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78876);
/* harmony import */ var styles_modules_newsAlert_TemplateFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(styles_modules_newsAlert_TemplateFields_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var styles_modules_Input_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47909);
/* harmony import */ var styles_modules_Input_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(styles_modules_Input_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var components_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44217);
/* harmony import */ var utils_alert_template__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36543);










var Editor = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 9612).then(__webpack_require__.bind(__webpack_require__, 29612));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29612)
            ];
        }
    },
    ssr: false
});
// The editor's full toolbar, as before the template; videos from YouTube and Vimeo
// only, the hosts the API keeps.
var ALERT_EDITOR_CONFIG = {
    mediaEmbed: {
        previewsInData: true,
        removeProviders: [
            "dailymotion",
            "spotify",
            "instagram",
            "twitter",
            "googleMaps",
            "flickr",
            "facebook", 
        ]
    }
};
var nextKey = 0;
var newKey = function() {
    return "question-".concat(nextKey++);
};
var TemplateFields = function(param) {
    var intro = param.intro, questions = param.questions, onChange = param.onChange, storedIntro = param.storedIntro;
    var isAdmin = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(store_auth__WEBPACK_IMPORTED_MODULE_4__/* .authSelector */ .aF).isAdmin;
    // Stable keys, so removing a middle question doesn't shift the others' inputs.
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(function() {
        return questions.map(newKey);
    }), keys = ref[0], setKeys = ref[1];
    var words = (0,utils_alert_template__WEBPACK_IMPORTED_MODULE_6__/* .countWords */ .Ht)((0,utils_alert_template__WEBPACK_IMPORTED_MODULE_6__/* .introText */ .mG)(intro));
    // Over the limit blocks everyone but admins (who only see the note) and an author
    // saving an intro whose text they didn't change.
    var limited = (0,utils_alert_template__WEBPACK_IMPORTED_MODULE_6__/* .introLimited */ .Vz)(intro, isAdmin, storedIntro);
    var over = words > utils_alert_template__WEBPACK_IMPORTED_MODULE_6__/* .MAX_INTRO_WORDS */ .aF;
    var setQuestion = function(index, value) {
        return onChange({
            intro: intro,
            questions: questions.map(function(q, i) {
                return i === index ? value : q;
            })
        });
    };
    var addQuestion = function() {
        setKeys((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(keys).concat([
            newKey()
        ]));
        onChange({
            intro: intro,
            questions: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(questions).concat([
                ""
            ])
        });
    };
    var removeQuestion = function(index) {
        setKeys(keys.filter(function(_, i) {
            return i !== index;
        }));
        onChange({
            intro: intro,
            questions: questions.filter(function(_, i) {
                return i !== index;
            })
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (styles_modules_newsAlert_TemplateFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default().fields),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (styles_modules_newsAlert_TemplateFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default().label),
                children: "Intro"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Editor, {
                data: intro,
                setData: function(html) {
                    return onChange({
                        intro: html,
                        questions: questions
                    });
                },
                height: "200px",
                config: ALERT_EDITOR_CONFIG,
                ariaLabel: "Intro"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: [
                    (styles_modules_newsAlert_TemplateFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default().count),
                    over && limited ? (styles_modules_newsAlert_TemplateFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default().over) : "", 
                ].join(" "),
                children: [
                    words,
                    " / ",
                    utils_alert_template__WEBPACK_IMPORTED_MODULE_6__/* .MAX_INTRO_WORDS */ .aF,
                    " words",
                    over && isAdmin && " (over the limit, allowed for admins)"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: (styles_modules_newsAlert_TemplateFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default().heading),
                children: utils_alert_template__WEBPACK_IMPORTED_MODULE_6__/* .ALERT_QUESTIONS_HEADING */ .ZD
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                className: (styles_modules_newsAlert_TemplateFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default().questions),
                children: questions.map(function(question, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        className: (styles_modules_newsAlert_TemplateFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default().question),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                className: (styles_modules_Input_module_scss__WEBPACK_IMPORTED_MODULE_9___default().input),
                                value: question,
                                onChange: function(e) {
                                    return setQuestion(index, e.target.value);
                                },
                                "aria-label": "Question ".concat(index + 1),
                                placeholder: "Question ".concat(index + 1)
                            }),
                            questions.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                type: "button",
                                className: (styles_modules_newsAlert_TemplateFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default().remove),
                                onClick: function() {
                                    return removeQuestion(index);
                                },
                                children: "Remove"
                            })
                        ]
                    }, keys[index]);
                })
            }),
            isAdmin && (0,utils_alert_template__WEBPACK_IMPORTED_MODULE_6__/* .filledQuestions */ .lp)(questions).length === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (styles_modules_newsAlert_TemplateFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default().count),
                children: "No questions (allowed for admins): the alert goes out without this heading."
            }),
            questions.length < utils_alert_template__WEBPACK_IMPORTED_MODULE_6__/* .MAX_QUESTIONS */ .xl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                title: "Add question",
                theme: "outline",
                onClick: addQuestion,
                classes: [
                    (styles_modules_newsAlert_TemplateFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default().add)
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TemplateFields);


/***/ }),

/***/ 29386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Alert_TimePicker; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@date-io/date-fns/build/index.esm.js + 107 modules
var index_esm = __webpack_require__(23433);
// EXTERNAL MODULE: ./node_modules/@material-ui/pickers/esm/useUtils-cfb96ac9.js
var useUtils_cfb96ac9 = __webpack_require__(87827);
// EXTERNAL MODULE: ./node_modules/@material-ui/pickers/esm/TimePicker.js + 1 modules
var TimePicker = __webpack_require__(25199);
// EXTERNAL MODULE: ./styles/modules/newsAlert/InputPicker.module.scss
var InputPicker_module = __webpack_require__(15260);
var InputPicker_module_default = /*#__PURE__*/__webpack_require__.n(InputPicker_module);
;// CONCATENATED MODULE: ./components/Svg/Clock.js

function Clock() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11 21.5C16.799 21.5 21.5 16.799 21.5 11C21.5 5.20101 16.799 0.5 11 0.5C5.20101 0.5 0.5 5.20101 0.5 11C0.5 16.799 5.20101 21.5 11 21.5ZM12.5 5V12.5L6.5 15.5736L5.375 13.625L10.25 11.1277L10.25 5H12.5Z",
            fill: "#212121"
        })
    });
}

;// CONCATENATED MODULE: ./components/Alert/TimePicker.js





var TimePicker_TimePicker = function(param) {
    var time = param.time, setTime = param.setTime, setTimeValid = param.setTimeValid;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (InputPicker_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useUtils_cfb96ac9.M, {
            utils: index_esm/* default */.Z,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimePicker/* KeyboardTimePicker */.e, {
                ampm: false,
                value: time,
                onChange: setTime,
                className: (InputPicker_module_default()).picker,
                keyboardIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Clock, {}),
                onError: function(error) {
                    return setTimeValid(!error);
                }
            })
        })
    });
};
/* harmony default export */ var Alert_TimePicker = (TimePicker_TimePicker);


/***/ }),

/***/ 25113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61385);
/* harmony import */ var styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Checkbox = function(param) {
    var name = param.name, label = param.label, register = param.register, initialValue = param.initialValue, onChange = param.onChange, className = param.className, error = param.error, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialValue), checked = ref[0], setChecked = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: [
            (styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().checkbox),
            className ? className : ""
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                name: name,
                id: name,
                type: "checkbox",
                disabled: disabled,
                defaultChecked: initialValue,
                checked: register ? undefined : checked,
                onChange: register ? undefined : function(param) {
                    var checked = param.target.checked;
                    setChecked(checked);
                    onChange ? onChange() : null;
                },
                className: (styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().input),
                ref: register ? register : undefined
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                htmlFor: name,
                className: (styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().label),
                children: label
            }),
            (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().error),
                children: error.message
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Checkbox);


/***/ }),

/***/ 84443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Svg_Facebook__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81361);
/* harmony import */ var _Svg_LinkedIn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26908);
/* harmony import */ var _Svg_Twitter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15288);




var SocialShare = function(param) {
    var platform = param.platform, url = param.url, fill = param.fill;
    var href;
    var icon;
    switch(platform){
        case "facebook":
            href = "https://www.facebook.com/sharer.php?u=";
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg_Facebook__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                fill: fill
            });
            break;
        case "twitter":
            href = "https://twitter.com/intent/tweet?url=";
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg_Twitter__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                fill: fill
            });
            break;
        case "linkedin":
            href = "https://www.linkedin.com/sharing/share-offsite/?url=";
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg_LinkedIn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                fill: fill
            });
            break;
    }
    var handleClick = function() {
        var left = (screen.width - 570) / 2;
        var top = (screen.height - 570) / 2;
        var params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;
        window.open(href + url, "NewWindow", params);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        onClick: handleClick,
        children: icon
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SocialShare);


/***/ }),

/***/ 36543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fv": function() { return /* binding */ alertTemplateError; },
/* harmony export */   "Ht": function() { return /* binding */ countWords; },
/* harmony export */   "Vz": function() { return /* binding */ introLimited; },
/* harmony export */   "ZD": function() { return /* binding */ ALERT_QUESTIONS_HEADING; },
/* harmony export */   "aF": function() { return /* binding */ MAX_INTRO_WORDS; },
/* harmony export */   "hz": function() { return /* binding */ alertTemplate; },
/* harmony export */   "lp": function() { return /* binding */ filledQuestions; },
/* harmony export */   "mG": function() { return /* binding */ introText; },
/* harmony export */   "xl": function() { return /* binding */ MAX_QUESTIONS; }
/* harmony export */ });
// Must match the API (src/api/alerts/alert-template.ts), which rejects anything
// this form would let through.
var ALERT_QUESTIONS_HEADING = "Questions for Newspagers";
var MAX_INTRO_WORDS = 150;
var MAX_QUESTIONS = 5;
var countWords = function() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return text.split(/\s+/).filter(Boolean).length;
};
// The intro is editor HTML. Inline tags can sit inside a word ("<b>Hel</b>lo");
// every other tag ends one.
var introText = function() {
    var html = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return html.replace(/<\/?(?:a|b|em|i|s|strong|u)\b[^>]*>/gi, "").replace(/<[^>]*>/g, " ").replace(/&nbsp;/gi, " ");
};
var filledQuestions = function() {
    var questions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return questions.map(function(question) {
        return question.trim();
    }).filter(Boolean);
};
// Alerts written before the template have no questions and keep their free-form body.
var alertTemplate = function(alert) {
    return Array.isArray(alert === null || alert === void 0 ? void 0 : alert.questions) ? {
        intro: alert.intro || "",
        questions: alert.questions
    } : null;
};
var plainText = function() {
    var html = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return introText(html).replace(/\s+/g, " ").trim();
};
// Same rule as the API: admins have no word limit, and neither has an author saving
// an intro (say, one an admin made longer) without changing its text.
var introLimited = function(intro) {
    var isAdmin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, storedIntro = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return !isAdmin && !(storedIntro && plainText(intro) === plainText(storedIntro));
};
// The first reason the template cannot be sent, or null. Like the API, admins may send
// no questions, and so may an author saving an alert that already has none.
var alertTemplateError = function(param) {
    var _intro = param.intro, intro = _intro === void 0 ? "" : _intro, _questions = param.questions, questions = _questions === void 0 ? [] : _questions, isAdmin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, storedIntro = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, storedQuestions = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    var text = introText(intro);
    if (!text.trim()) return "Write an intro.";
    if (introLimited(intro, isAdmin, storedIntro) && countWords(text) > MAX_INTRO_WORDS) return "The intro must be ".concat(MAX_INTRO_WORDS, " words or fewer.");
    if (filledQuestions(questions).length < 1 && !isAdmin && !(Array.isArray(storedQuestions) && storedQuestions.length === 0)) return "Add at least one question.";
    return null;
};


/***/ }),

/***/ 25374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BA": function() { return /* binding */ researchOfferLocked; },
/* harmony export */   "FS": function() { return /* binding */ storedReservation; },
/* harmony export */   "K": function() { return /* binding */ RESEARCH_TEXT_MAX; },
/* harmony export */   "KA": function() { return /* binding */ reserveErrorMessage; },
/* harmony export */   "MR": function() { return /* binding */ researchAdminStatus; },
/* harmony export */   "RY": function() { return /* binding */ RESEARCH_TEXT_TOO_LONG; },
/* harmony export */   "Sh": function() { return /* binding */ researchOfferError; },
/* harmony export */   "U6": function() { return /* binding */ researchOfferBody; },
/* harmony export */   "XE": function() { return /* binding */ storeReservation; },
/* harmony export */   "__": function() { return /* binding */ researchOfferDraft; },
/* harmony export */   "dS": function() { return /* binding */ researchOfferChanged; },
/* harmony export */   "df": function() { return /* binding */ forgetReservation; },
/* harmony export */   "dp": function() { return /* binding */ researchTextTooLong; },
/* harmony export */   "fp": function() { return /* binding */ RESEARCH_PRICES; },
/* harmony export */   "gX": function() { return /* binding */ priceLabel; },
/* harmony export */   "mf": function() { return /* binding */ researchBoxView; },
/* harmony export */   "uP": function() { return /* binding */ researchKeepsSlotsOff; }
/* harmony export */ });
/* unused harmony exports RESERVATION_MAX_AGE_MS, parseStoredReservation */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);
// Story sponsorship (research): one company pays to be named as sponsor of the
// research behind an admin's News Alert and its story.
// The API accepts only these, in pence.

var RESEARCH_PRICES = [
    10000,
    25000,
    50000,
    75000,
    100000
];
var DEFAULT_PRICE = 50000;
var priceLabel = function(pence) {
    return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP",
        minimumFractionDigits: pence % 100 ? 2 : 0
    }).format(pence / 100);
};
// The admin's whole intro paragraph; the API allows the same.
var RESEARCH_TEXT_MAX = 600;
var RESEARCH_TEXT_TOO_LONG = "Shorten the sponsorship text to ".concat(RESEARCH_TEXT_MAX, " characters.");
// Like the API, a text saved before the limit may stay as it is; a changed one must fit.
var researchTextTooLong = function(draft, storedText) {
    var text = ((draft === null || draft === void 0 ? void 0 : draft.researchDetail) || "").trim();
    return text.length > RESEARCH_TEXT_MAX && text !== (storedText !== null && storedText !== void 0 ? storedText : "");
};
var ref, ref1;
var researchOfferDraft = function(row) {
    return {
        enabled: Boolean(row === null || row === void 0 ? void 0 : row.enabled),
        researchDetail: (ref = row === null || row === void 0 ? void 0 : row.researchDetail) !== null && ref !== void 0 ? ref : "",
        pricePence: (ref1 = row === null || row === void 0 ? void 0 : row.pricePence) !== null && ref1 !== void 0 ? ref1 : DEFAULT_PRICE
    };
};
// The API refuses any change once a buyer has reserved or paid.
var researchOfferLocked = function(row) {
    return Boolean(row) && row.status !== "available";
};
var researchAdminStatus = function(row) {
    if ((row === null || row === void 0 ? void 0 : row.status) === "sold") return "Sold to ".concat(row.sponsorName || "…");
    if ((row === null || row === void 0 ? void 0 : row.status) === "reserved") {
        return "Checkout in progress (".concat(row.sponsorName || "buyer", ")");
    }
    return null;
};
// Caught before any request, so a create never leaves half a save behind.
var researchOfferError = function(draft) {
    var storedText = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (!(draft === null || draft === void 0 ? void 0 : draft.enabled)) return null;
    if (!draft.researchDetail.trim()) {
        return "Write the sponsorship text before offering the story sponsorship.";
    }
    return researchTextTooLong(draft, storedText) ? RESEARCH_TEXT_TOO_LONG : null;
};
// Without a detail the API keeps the stored one, so switching off loses nothing.
var researchOfferBody = function(draft) {
    var researchDetail = draft.researchDetail.trim();
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        enabled: draft.enabled,
        pricePence: draft.pricePence
    }, researchDetail ? {
        researchDetail: researchDetail
    } : {});
};
// Same rule as the API: an enabled offer, or one that is reserved or sold, keeps the
// alert's story sponsor and expert answers off.
var researchKeepsSlotsOff = function(row) {
    return Boolean(row && (row.enabled || row.status !== "available"));
};
// Only a real change is saved: an untouched alert has nothing to write.
var researchOfferChanged = function(draft, row) {
    if (researchOfferLocked(row)) return false;
    if (!row) return draft.enabled;
    var _researchDetail;
    return draft.enabled !== Boolean(row.enabled) || draft.pricePence !== row.pricePence || draft.researchDetail.trim() !== ((_researchDetail = row.researchDetail) !== null && _researchDetail !== void 0 ? _researchDetail : "");
};
// What the public box shows. A buyer holding the reservation may go back to
// their own checkout, so for them a reserved slot still shows the form.
var researchBoxView = function(live) {
    var hasToken = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!(live === null || live === void 0 ? void 0 : live.enabled)) return null;
    if (live.status === "sold") return "sold";
    if (live.status === "reserved" && !hasToken) return "reserved";
    return "available";
};
var RESERVE_ERRORS = {
    IN_PROGRESS: "Your checkout is being prepared, try again in a moment.",
    RESERVED: "Sponsorship being taken, check back shortly.",
    SOLD: "This research has already been sponsored.",
    NOT_OFFERED: "This research is no longer offered for sponsorship."
};
var reserveErrorMessage = function(response) {
    var ref, ref1;
    var known = RESERVE_ERRORS[response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.code];
    if (known) return known;
    if ((response === null || response === void 0 ? void 0 : response.status) === 429) {
        return "Too many attempts, try again in a minute.";
    }
    if ((response === null || response === void 0 ? void 0 : response.status) === 412) {
        return "Our spam check is unavailable, try again shortly.";
    }
    if ((response === null || response === void 0 ? void 0 : response.status) === 503) {
        return "Sponsorship is not available right now. Please try again later.";
    }
    var message = response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.message;
    if ([
        400,
        403,
        409
    ].includes(response === null || response === void 0 ? void 0 : response.status) && message) {
        return Array.isArray(message) ? message.join(" ") : message;
    }
    return "Something went wrong. Please try again.";
};
var storageKey = function(alertId) {
    return "research-sponsor-".concat(alertId);
};
// A Stripe session lasts 33 minutes; past this nothing stored can be resumed.
var RESERVATION_MAX_AGE_MS = 35 * 60 * 1000;
// Storage can be blocked (private mode, site data off); the buyer then simply
// can't resume or release, and the slot frees itself when Stripe expires it.
var withStorage = function(type, use) {
    try {
        return use(window[type]);
    } catch (e) {
        return null;
    }
};
var fresh = function(raw, now) {
    try {
        var value = JSON.parse(raw);
        var age = now - value.savedAt;
        return age >= 0 && age < RESERVATION_MAX_AGE_MS ? value : null;
    } catch (e) {
        return null;
    }
};
// The token lives in localStorage, so the cancel page can release it whatever
// tab Stripe returns to; what the buyer typed stays in this tab's sessionStorage.
// Returns { reservationToken, fields }, fields null unless complete; null when
// there is no fresh token.
var parseStoredReservation = function(rawToken, rawFields, now) {
    var ref, ref1;
    var reservationToken = (ref = fresh(rawToken, now)) === null || ref === void 0 ? void 0 : ref.reservationToken;
    if (typeof reservationToken !== "string" || !reservationToken) {
        return null;
    }
    var fields = (ref1 = fresh(rawFields, now)) === null || ref1 === void 0 ? void 0 : ref1.fields;
    var complete = typeof (fields === null || fields === void 0 ? void 0 : fields.sponsorName) === "string" && fields.sponsorName.trim() && typeof fields.email === "string" && fields.email.trim();
    return {
        reservationToken: reservationToken,
        fields: complete ? {
            sponsorName: fields.sponsorName,
            website: typeof fields.website === "string" ? fields.website : "",
            email: fields.email
        } : null
    };
};
var storedReservation = function(alertId) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    return parseStoredReservation(withStorage("localStorage", function(s) {
        return s.getItem(storageKey(alertId));
    }), withStorage("sessionStorage", function(s) {
        return s.getItem(storageKey(alertId));
    }), now);
};
var storeReservation = function(alertId, reservationToken, fields) {
    var savedAt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Date.now();
    withStorage("localStorage", function(s) {
        return s.setItem(storageKey(alertId), JSON.stringify({
            reservationToken: reservationToken,
            savedAt: savedAt
        }));
    });
    withStorage("sessionStorage", function(s) {
        return s.setItem(storageKey(alertId), JSON.stringify({
            fields: fields,
            savedAt: savedAt
        }));
    });
};
var forgetReservation = function(alertId) {
    withStorage("localStorage", function(s) {
        return s.removeItem(storageKey(alertId));
    });
    withStorage("sessionStorage", function(s) {
        return s.removeItem(storageKey(alertId));
    });
};


/***/ }),

/***/ 93373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mg": function() { return /* binding */ sourcePageText; },
/* harmony export */   "Uo": function() { return /* binding */ SOURCE_LABEL_MAX; },
/* harmony export */   "WK": function() { return /* binding */ sourcePageRel; },
/* harmony export */   "uO": function() { return /* binding */ pickSource; },
/* harmony export */   "w7": function() { return /* binding */ sourcePageHref; }
/* harmony export */ });
// The backend stores the source page clean, so the campaign follows the alert's current slug.
var sourcePageHref = function(url, slug) {
    if (!url) return null;
    try {
        var tagged = new URL(url);
        // The API only accepts https, but the CMS can write the column directly.
        if (tagged.protocol !== "https:") return null;
        tagged.searchParams.set("utm_source", "newspage");
        tagged.searchParams.set("utm_medium", "alert");
        if (slug) tagged.searchParams.set("utm_campaign", slug);
        return tagged.toString();
    } catch (e) {
        return null;
    }
};
// Paid placements are rel="sponsored"; a link an expert sets for free is user-generated.
var sourcePageRel = function(isSponsored) {
    return "".concat(isSponsored ? "sponsored" : "ugc", " noopener");
};
var sourcePageText = function(label, url) {
    if (label) return label;
    try {
        return new URL(url).hostname.replace(/^www\./, "");
    } catch (e) {
        return url;
    }
};
var SOURCE_LABEL_MAX = 60;
var pickSource = function(alert) {
    return {
        sourceUrl: (alert === null || alert === void 0 ? void 0 : alert.sourceUrl) || "",
        sourceLabel: (alert === null || alert === void 0 ? void 0 : alert.sourceLabel) || "",
        isSponsored: !!(alert === null || alert === void 0 ? void 0 : alert.isSponsored),
        sourceBy: (alert === null || alert === void 0 ? void 0 : alert.sourceBy) || ""
    };
};


/***/ }),

/***/ 61385:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__2Wn0I","input":"Checkbox_input__s0QyL","label":"Checkbox_label__qWLb_","error":"Checkbox_error__haSHE"};

/***/ }),

/***/ 15260:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InputPicker_wrapper__Sr3VC"};

/***/ }),

/***/ 51495:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"newsroom":"Newsroom_newsroom__9yZ3C","bar":"Newsroom_bar__cLqAk","barStatus":"Newsroom_barStatus__PYyzI","ok":"Newsroom_ok__0KfAG","error":"Newsroom_error__sA_bb","label":"Newsroom_label__KaYHF","count":"Newsroom_count__pYRri","hint":"Newsroom_hint__gK51z","input":"Newsroom_input__bPtjX","textarea":"Newsroom_textarea__SPDvv","headlineInput":"Newsroom_headlineInput__yCfN_","rawPanel":"Newsroom_rawPanel__IpSIH","rawStatus":"Newsroom_rawStatus__KhRzz","thinWarning":"Newsroom_thinWarning__wensW","rawActions":"Newsroom_rawActions__o_Hcz","editor":"Newsroom_editor__B05UY","editorIntro":"Newsroom_editorIntro__IG6ur","kicker":"Newsroom_kicker__QSjTx","editorGrid":"Newsroom_editorGrid__sQ2U_","editorMain":"Newsroom_editorMain__iWEaA","editorSide":"Newsroom_editorSide__FB3em","editorActions":"Newsroom_editorActions__OyZzO","unsaved":"Newsroom_unsaved__K45Bj","seo":"Newsroom_seo__DaS_M","seoHead":"Newsroom_seoHead__RN9qH","snippet":"Newsroom_snippet__pb3Cq","snippetUrl":"Newsroom_snippetUrl__BNXN7","snippetTitle":"Newsroom_snippetTitle__XTOtj","snippetText":"Newsroom_snippetText__CA8x4","lengthBar":"Newsroom_lengthBar__eV67Z","bar-good":"Newsroom_bar-good__VmkN9","bar-ok":"Newsroom_bar-ok__t9mqZ","bar-bad":"Newsroom_bar-bad__tumxL","checkGroup":"Newsroom_checkGroup__1_AHW","checks":"Newsroom_checks__d47gw","dot":"Newsroom_dot__SdO9g","dot-good":"Newsroom_dot-good__b6BHh","dot-ok":"Newsroom_dot-ok__A5GfH","dot-bad":"Newsroom_dot-bad__bCw_F","dot-info":"Newsroom_dot-info__J3UZR","story":"Newsroom_story__LYIUP","storySponsor":"Newsroom_storySponsor__UJ63r","storySponsorLabel":"Newsroom_storySponsorLabel__AVLaK","storyBody":"Newsroom_storyBody__Ed4Xw","storyHeadline":"Newsroom_storyHeadline__azLB4","storyMetaRow":"Newsroom_storyMetaRow__0ScrT","copyStory":"Newsroom_copyStory__mAyLS","storyMeta":"Newsroom_storyMeta__w_bKO","leadImage":"Newsroom_leadImage__H5z4z","bylinePhoto":"Newsroom_bylinePhoto__7rOP7","authorBlock":"Newsroom_authorBlock__3Hrhr","authorFoot":"Newsroom_authorFoot__jOeXF","authorPhoto":"Newsroom_authorPhoto__fBFSu","authorName":"Newsroom_authorName__Q25x5","authorRole":"Newsroom_authorRole__NyObG","authorBio":"Newsroom_authorBio__qjP_I","authorLinks":"Newsroom_authorLinks__38LFc","rawDivider":"Newsroom_rawDivider__yNnbE","reportedBy":"Newsroom_reportedBy__8wQ_6","related":"Newsroom_related__AT9h1","sourceCredit":"Newsroom_sourceCredit__SWZU_","sourceReminder":"Newsroom_sourceReminder__ch5bL","rawBadge":"Newsroom_rawBadge__uASw6","suggestedLink":"Newsroom_suggestedLink__fSHZK","rerawMarker":"Newsroom_rerawMarker__1R_f_","faqOffer":"Newsroom_faqOffer__Mtn2Q","leadImagePreview":"Newsroom_leadImagePreview__YWYc3","leadImageActions":"Newsroom_leadImageActions__QaJ6P","checkboxLabel":"Newsroom_checkboxLabel__bFPS8","faqStatus":"Newsroom_faqStatus__zDRDF","faqQuestion":"Newsroom_faqQuestion__KS56h","expertAnswers":"Newsroom_expertAnswers__G4S0W","sponsoredLabel":"Newsroom_sponsoredLabel__mMaml","expertAnswersHeading":"Newsroom_expertAnswersHeading__MNNbP","expertAnswersIntro":"Newsroom_expertAnswersIntro__m0oOz","expertAnswer":"Newsroom_expertAnswer__KeSn3","expertAnswersNote":"Newsroom_expertAnswersNote__0N6Xm","faqReview":"Newsroom_faqReview__OV32g","overLimit":"Newsroom_overLimit__KrelQ","topics":"Newsroom_topics__qTp5b","topicList":"Newsroom_topicList__Yk6m9","topicGroup":"Newsroom_topicGroup__BY49t","topicNoPage":"Newsroom_topicNoPage__wWDjg","linkButton":"Newsroom_linkButton___L7m_","topicActions":"Newsroom_topicActions__bNHcl"};

/***/ }),

/***/ 48390:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SlugField_wrapper__j6g_G","label":"SlugField_label__aJdgw","row":"SlugField_row__6rGg8","prefix":"SlugField_prefix__pB2Ba","input":"SlugField_input__gn2MS","status":"SlugField_status__1gSUo","available":"SlugField_available__ZjWJg","taken":"SlugField_taken__BgD8h"};

/***/ }),

/***/ 283:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fields":"SourcePage_fields__6tr_6","description":"SourcePage_description__Rvoyb","hint":"SourcePage_hint___tlQL","source":"SourcePage_source__mZoyQ"};

/***/ }),

/***/ 78876:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"label":"TemplateFields_label__A0mNp","count":"TemplateFields_count__kd3Ho","over":"TemplateFields_over__bN8h5","heading":"TemplateFields_heading__axgvt","questions":"TemplateFields_questions__xNHHf","question":"TemplateFields_question__J9nwq","remove":"TemplateFields_remove__isdHB","add":"TemplateFields_add__a_RBY"};

/***/ })

}]);